import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const EfasDistribution = ({
    efaLegend,
    doughnutData,
    options
}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="EFAs-distribution-cell">
                <h3 className='title-distribution'>{t('extended_report.EFAs_distribution')}</h3>
                <p className='subtitle-distribution'>{t('extended_report.ditribution_graph')}</p>
                <div className='distribution'>
                    <div>
                        <div>
                            {efaLegend.map(({ label, value, color }) => (
                                <div key={label}>
                                    <div className='content-distribution'>
                                        <div className='dot-style' style={{ backgroundColor: color }}></div>
                                        <p>{label}</p>
                                    </div>
                                    <p className='numberOfProyects'>{`${value} ${t('one_pager_report.projects')}`}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='doughnut-style'>
                        <Doughnut data={doughnutData} options={options} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EfasDistribution